import { AlternativeStatusDTO, SpreadsheetColumnToAlternativePropertyMapping } from "@Alternatives/Model";
import { MonthYear } from "@common/types";
import { ICommandBase } from "@Alternatives/cqrs";

export class ExportAlternativesCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.AlternativesLists.Commands.ExportAlternativesCommandV1, TCh.Domain.Alternatives';

	WorkspaceId: number;
	Id: string;
	ViewDefId: string;

	constructor(workspaceId: number, alternativesListId: number, viewDefId: string)
	{
		this.WorkspaceId = workspaceId;
		this.Id = alternativesListId.toString();
		this.ViewDefId = viewDefId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.AlternativesLists.Commands.ExportAlternativesCommandV1, TCh.Domain.Alternatives';
	}
}


export class UpdateAlternativeLabelsCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.AlternativesLists.Commands.UpdateAlternativeLabelsCommandV1, TCh.Domain.Alternatives';

	WorkspaceId: number;
	Id: string;
	AlternativeLabel: string;
	AlternativesLabel: string;

	constructor(workspaceId: number, alternativesListId: number, alternativeLabel: string, alternativesLabel: string)
	{
		this.WorkspaceId = workspaceId;
		this.Id = alternativesListId.toString();
		this.AlternativeLabel = alternativeLabel;
		this.AlternativesLabel = alternativesLabel;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.AlternativesLists.Commands.UpdateAlternativeLabelsCommandV1, TCh.Domain.Alternatives';
	}
}

export class UpdateKanbanStatusesCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.AlternativesLists.Commands.UpdateKanbanStatusesCommandV1, TCh.Domain.Alternatives';

	WorkspaceId: number;
	Id: string;
	Statuses: AlternativeStatusDTO[];

	constructor(workspaceId: number, alternativesListId: number, statuses: AlternativeStatusDTO[])
	{
		this.WorkspaceId = workspaceId;
		this.Id = alternativesListId.toString();
		this.Statuses = statuses;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.AlternativesLists.Commands.UpdateKanbanStatusesCommandV1, TCh.Domain.Alternatives';
	}
}

export class DeleteKanbanStatusCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.AlternativesLists.Commands.DeleteKanbanStatusCommandV1, TCh.Domain.Alternatives';

	WorkspaceId: number;
	ProjectId: number;
	Id: string;
	StatusId: number;

	constructor(workspaceId: number, projectId: number, alternativesListId: number, statusId: number)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.Id = alternativesListId.toString();
		this.StatusId = statusId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.AlternativesLists.Commands.DeleteKanbanStatusCommandV1, TCh.Domain.Alternatives';
	}
}

export class DeleteAlternativesCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.AlternativesLists.Commands.DeleteAlternativesCommandV1, TCh.Domain.Alternatives';

	WorkspaceId: number;
	ProjectId: number;
	Id: string; 
	AlternativeIds: string[]; 
	UserId: number;

	constructor(workspaceId: number, projectId: number, alternativesListId: number, alternativeIds: string[], userId: number)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.Id = alternativesListId.toString();
		this.AlternativeIds = alternativeIds;
		this.UserId = userId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.AlternativesLists.Commands.DeleteAlternativesCommandV1, TCh.Domain.Alternatives';
	}
}

export class UpdateMultipleAlternativesStatusCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.AlternativesLists.Commands.UpdateMultipleAlternativesStatusCommandV1, TCh.Domain.Alternatives';

	UserId: number;
	WorkspaceId: number;
	ProjectId: number;
	Id: string;
	AlternativeIds: string[];
	StatusId: number;

	constructor(userId: number, workspaceId: number, projectId: number, alternativesListId: number, alternativeIds: string[], statusId: number)
	{
		this.UserId = userId;
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.Id = alternativesListId.toString();
		this.AlternativeIds = alternativeIds;
		this.StatusId = statusId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.AlternativesLists.Commands.UpdateMultipleAlternativesStatusCommandV1, TCh.Domain.Alternatives';
	}
}

export class UpdateMultipleAlternativesAttributeValueCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.AlternativesLists.Commands.UpdateMultipleAlternativesAttributeValueCommandV1, TCh.Domain.Alternatives';

	UserId: number;
	WorkspaceId: number;
	ProjectId: number;
	Id: string;
	AlternativeIds: string[];
	AttributeId: number;
	Value: string;

	constructor(userId: number, workspaceId: number, projectId: number, alternativesListId: number, alternativeIds: string[], attributeId: number, value: string)
	{
		this.UserId = userId;
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.Id = alternativesListId.toString();
		this.AlternativeIds = alternativeIds;
		this.AttributeId = attributeId;
		this.Value = value;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.AlternativesLists.Commands.UpdateMultipleAlternativesAttributeValueCommandV1, TCh.Domain.Alternatives';
	}
}
export class UpdateMultipleAlternativesStartDateCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.AlternativesLists.Commands.UpdateMultipleAlternativesStartDateCommandV1, TCh.Domain.Alternatives';

	WorkspaceId: number;
	ProjectId: number;
	Id: string;
	AlternativeIds: string[];
	StartDate: MonthYear | null;

	constructor(workspaceId: number, projectId: number, alternativesListId: number, alternativeIds: string[], startDate: MonthYear | null)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.Id = alternativesListId.toString();
		this.AlternativeIds = alternativeIds;
		this.StartDate = startDate;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.AlternativesLists.Commands.UpdateMultipleAlternativesStartDateCommandV1, TCh.Domain.Alternatives';
	}
}
export class UpdateMultipleAlternativesCommitmentDateCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.AlternativesLists.Commands.UpdateMultipleAlternativesCommitmentDateCommandV1, TCh.Domain.Alternatives';

	WorkspaceId: number;
	ProjectId: number;
	Id: string;
	AlternativeIds: string[];
	CommitmentDate: MonthYear | null;

	constructor(workspaceId: number, projectId: number, alternativesListId: number, alternativeIds: string[], commitmentDate: MonthYear | null)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.Id = alternativesListId.toString();
		this.AlternativeIds = alternativeIds;
		this.CommitmentDate = commitmentDate;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.AlternativesLists.Commands.UpdateMultipleAlternativesCommitmentDateCommandV1, TCh.Domain.Alternatives';
	}
}

export class RenameAttributesSectionCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.AlternativesLists.Commands.RenameAttributesSectionCommandV1, TCh.Domain.Alternatives';

	WorkspaceId: number;
	ProjectId: number;
	Id: string;
	OldName: string;
	NewName: string;

	constructor(workspaceId: number, projectId: number, alternativesListId: number, oldName: string, newName: string)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.Id = alternativesListId.toString();
		this.OldName = oldName;
		this.NewName = newName;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.AlternativesLists.Commands.RenameAttributesSectionCommandV1, TCh.Domain.Alternatives';
	}
}
export class DownloadEmptyAlternativesSpreadsheetCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.AlternativesLists.Commands.DownloadEmptyAlternativesSpreadsheetCommandV1, TCh.Domain.Alternatives';

	WorkspaceId: number;
	ProjectId: number;
	Id: string;

	constructor(workspaceId: number, projectId: number, alternativesListId: number)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.Id = alternativesListId.toString();
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.AlternativesLists.Commands.DownloadEmptyAlternativesSpreadsheetCommandV1, TCh.Domain.Alternatives';
	}
}
export class ImportAlternativesFromSpreadsheetCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.AlternativesLists.Commands.ImportAlternativesFromSpreadsheetCommandV1, TCh.Domain.Alternatives';

	UserId: number;
	WorkspaceId: number;
	ProjectId: number;
	Id: string;
	BlobId: string;
	UpdateExisting: boolean;
	ColumnMappings: SpreadsheetColumnToAlternativePropertyMapping[];
	constructor(userId: number, workspaceId: number, projectId: number, alternativesListId: number, blobId: string, updateExisting: boolean, columnMappings: SpreadsheetColumnToAlternativePropertyMapping[])
	{
		this.UserId = userId;
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.Id = alternativesListId.toString();
		this.BlobId = blobId;
		this.UpdateExisting = updateExisting;
		this.ColumnMappings = columnMappings;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.AlternativesLists.Commands.ImportAlternativesFromSpreadsheetCommandV1, TCh.Domain.Alternatives';
	}
}


